export const tradingSeatsContext = 'seatTrade'
